import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

import { CommentComponent } from './comment.component';
export { CommentComponent };

import { ActionDirective } from './directives/action.directive';
export { ActionDirective };

export const MODULE_IMPORTS = [CommonModule, GalaxyAvatarModule];

export const MODULE_DECLARATIONS = [CommentComponent, ActionDirective];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: MODULE_DECLARATIONS,
})
export class GalaxyCommentModule {}
